export enum StoreAvailableAdjustmentRequestEnum {
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED'
}

export enum StoreAvailableAdjustmentRequestRemarkTypeEnum {
  CANCEL_BY_NEWER_SU = 'CANCEL_BY_NEWER_SU',
  CANCEL_BY_QI = 'CANCEL_BY_QI',
  CANCEL_BY_SG = 'CANCEL_BY_SG'
}
